export default function(data, dropdownValues, redirect, forCreditInfo) {
  var self = this;
  self.$el = $('#js-enrollment-info-form');

  self.dropdownValues = ko.observable();
  self.booleanDropdown = ['True', 'False'];

  self.saving = ko.observable(false);

  self.profile = ko.observable();
  self.forCreditInfo = ko.observable();
  self.booleans = {};

  self.fetchLocationData = function(params) {
    $.getJSON(Kadenze.Routes.locations_path(params)).pipe(function (data, status, jqXHR) {
      self.dropdownValues()['address.country'](data.countries.sort());
      self.dropdownValues()['address.state'](data.states.sort());
      $('.selectpicker').selectpicker('refresh');
    });
  };

  self.bindData = function(data, dropdownValues, forCreditInfo) {
    var mapped = ko.mapping.fromJS(data);
    self.profile(mapped.profile);
    mapped = ko.mapping.fromJS(forCreditInfo);
    self.forCreditInfo(mapped);
    _.each(forCreditInfo, function(val, attr) {
      var observable = ko.observable(!!val);
      observable.subscribe(function(value){
        self.forCreditInfo()[attr](value);
      });
      self.booleans[attr] = observable;
    });
    mapped = ko.mapping.fromJS(dropdownValues);
    self.dropdownValues(mapped);

    self.initStateCountrySelect();
  };

  self.initStateCountrySelect = function() {
    self.forCreditInfo()['address.country'].subscribe(function(country) {
      $(document).click(); //Hack to get selectpicker to hide
      self.fetchLocationData({country: country});
    });

    self.forCreditInfo()['address.state'].subscribe(function(state) {
      $(document).click(); //Hack to get selectpicker to hide
    });
  };

  self.initUI = function() {

  };

  self.save = function(item, event) {
    var url = Kadenze.Routes.users_path();
    var method = 'PUT';
    var data = {user: {for_credit_info: ko.mapping.toJS(self.forCreditInfo)}};

    self.client_errors = ko.validation.group(self.forCreditInfo(), { deep: true });
    if (self.client_errors().length === 0) {
      Kadenze.UIUtil.makeRequest(url, method, data, self.$el,
        function(xhr, settings) { //BeforeSave
          Kadenze.UIUtil.showLoadingIndicator(self.$el);
        },
        function(data, textStatus, xhr) { //Success
          var url = redirect ? redirect : Kadenze.Routes.user_profile_path(self.profile().id());
          Kadenze.Request.pjax({
            url: url,
            container: '#main-pjax-container'
          });
        },
        function(xhr, textStatus, errorThrown) { //Error
          Kadenze.UIUtil.showNotice(self.$el, xhr.responseJSON, 3000);
        },
        function(xhr, textStatus) { //Complete
          Kadenze.UIUtil.hideLoadingIndicator(self.$el);
        });
    } else {
      self.client_errors.showAllMessages();
    }
  };

  const __construct = function(that) {
    that.bindData(data, dropdownValues, forCreditInfo);
  }(this);
}
